export const GET_EAN_FROM_STOCK_MANAGER = 'GET_EAN_FROM_STOCK_MANAGER';
export const getEanFromStockManager = data => ({
  type: GET_EAN_FROM_STOCK_MANAGER,
  payload: data
});

export const SET_COMMANDS = 'SET_COMMANDS';
export const setCommands = data => ({ type: SET_COMMANDS, data });

export const ADD_EAN_FROM_STOCK_MANAGER = 'ADD_EAN_FROM_STOCK_MANAGER';
export const addEanFromStockManager = barcodeValues => ({
  type: ADD_EAN_FROM_STOCK_MANAGER,
  payload: barcodeValues
});

export const ADD_WARNING_REFERENCE_EXIST = 'ADD_WARNING_REFERENCE_EXIST';

export const CHECK_IF_REFERENCE_ALREADY_EXIST =
  'CHECK_IF_REFERENCE_ALREADY_EXIST';
export const checkIfReferenceAlreadyExist = references => ({
  type: CHECK_IF_REFERENCE_ALREADY_EXIST,
  payload: references
});

export const ADD_ERRORS_ITEM = 'ADD_ERRORS_ITEM';
export const addErrorsItem = data => ({ type: ADD_ERRORS_ITEM, data });

export const ADD_WARNINGS = 'ADD_WARNINGS';
export const addWarnings = data => ({ type: ADD_WARNINGS, data });

export const UPDATE_COMMAND_IMPORTATION = 'UPDATE_COMMAND_IMPORTATION';
export const updateCommandImportation = data => ({
  type: UPDATE_COMMAND_IMPORTATION,
  data
});

export const DELETE_COMMAND = 'DELETE_COMMAND';
export const deleteCommand = data => ({ type: DELETE_COMMAND, data });

export const OPEN_DIALOG_BINDING_OFFER = 'OPEN_DIALOG_BINDING_OFFER';
export const openDialogBindingOffer = data => ({
  type: OPEN_DIALOG_BINDING_OFFER,
  data
});

export const SET_UNKNOW_DELIVERY_OFFER = 'SET_UNKNOW_DELIVERY_OFFER';
export const setUnknowDeliveryOffer = data => ({
  type: SET_UNKNOW_DELIVERY_OFFER,
  data
});

export const BIND_OFFER_CODE = 'BIND_OFFER_CODE';
export const BIND_OFFER_CODE_SAGA = 'BIND_OFFER_CODE_SAGA';
export const bindOfferCode = data => ({
  type: BIND_OFFER_CODE_SAGA,
  payload: data
});

export const CREATE_BATCH = 'CREATE_BATCH';
export const CREATE_BATCH_SUCCESS = 'CREATE_BATCH_SUCCESS';
export const createBatch = commands => ({
  type: CREATE_BATCH,
  payload: commands
});

export const RESET_IMPORT_COMMANDS = 'RESET_IMPORT_COMMANDS';
export const resetImportCommands = () => ({ type: RESET_IMPORT_COMMANDS });

export const HANDLE_COURIER_DIALOG = 'HANDLE_COURIER_DIALOG';
export const handleCoursierModal = data => ({
  type: HANDLE_COURIER_DIALOG,
  data
});

export const SET_PRODUCT_IS_IN_STOCK = 'SET_PRODUCT_IS_IN_STOCK';
export const setProductIsInStock = data => ({
  type: SET_PRODUCT_IS_IN_STOCK,
  data
});

export const OPEN_SELECT_FORMAT_DIALOG = 'OPEN_SELECT_FORMAT_DIALOG';
export const openSelectFormatDialog = data => ({
  type: OPEN_SELECT_FORMAT_DIALOG,
  data
});

export const SET_SELECTED_FORMAT = 'SET_SELECTED_FORMAT';
export const setSelectedFormat = data => ({ type: SET_SELECTED_FORMAT, data });

export const HANDLE_LOADER = 'HANDLE_LOADER';
